import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, MapPin, Home, Plus } from "lucide-react";
import { getStatusBadgeStyle } from "./utils";

const StatusBadge = ({ status }) => (
  <Badge className={`${getStatusBadgeStyle(status)} font-medium`}>
    {status}
  </Badge>
);

export const BookingsTab = ({ bookings }) => (
  <Card className="bg-white border-[#E2E8E0]">
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle className="text-[#1A2E12]">Booking History</CardTitle>
      <Link to="/booking">
        <Button
          className="bg-[#2D5016] hover:bg-[#1A2E12]"
          data-testid="book-new-btn"
        >
          <Plus className="w-4 h-4 mr-2" />
          Book New Clean
        </Button>
      </Link>
    </CardHeader>
    <CardContent>
      {bookings.length === 0 ? (
        <div className="text-center py-12">
          <Calendar className="w-12 h-12 text-[#E2E8E0] mx-auto mb-4" />
          <p className="text-[#5C6B57] mb-4">No bookings yet</p>
          <Link to="/booking">
            <Button className="bg-[#2D5016] hover:bg-[#1A2E12]">
              Book Your First Clean
            </Button>
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {bookings.map((booking) => (
            <div
              key={booking.id}
              className="border border-[#E2E8E0] rounded-xl p-4 hover:shadow-md transition-shadow"
            >
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-semibold text-[#1A2E12]">
                      {booking.service_name}
                    </h3>
                    <StatusBadge status={booking.status} />
                    <StatusBadge status={booking.payment_status} />
                  </div>
                  <div className="flex flex-wrap gap-4 text-sm text-[#5C6B57]">
                    <span className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {booking.booking_date} at {booking.booking_time}
                    </span>
                    <span className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      {booking.postcode}
                    </span>
                    <span className="flex items-center gap-1">
                      <Home className="w-4 h-4" />
                      {booking.bedrooms} bed, {booking.bathrooms} bath
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-[#2D5016]">
                    £{booking.total_price.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
